
import home1 from "../../assets/home1.png";

const Home = () => {
  return (
    <div className="efficiency-page">
      <div className="page-container">
        <div className="row justify-content-center">
          <div className="col-12">
            <h5 className="mb-4">Welcome</h5>
          </div>
        </div>
        <div className="row">
            <div className="img-container">
                <img src={home1} alt="home1" className="loader-img"/>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
